export const ECasePrimeStatus = {
  Classic: 'CLA',
  Prime: 'PRI',
  Sub: 'SUB',
};
